import * as React from 'react'
import useMobile from './hooks/useMobile'

const EmptyTable = (props) => {
    const { isMobile } = useMobile()
    
    return (
        <div style={{
            width: isMobile ? '100%' : 'calc(100% - 280px)',
            height: '100vh',
            padding: isMobile ? 'var(--spacing-sm)' : '8px',
            background: 'var(--black)',
            marginLeft: isMobile ? '0' : '280px'
        }}>
            {!isMobile && (
                <h1 style={{ 
                    marginTop: '8px',
                    marginBottom: '8px',
                    marginLeft: '0px',
                    fontWeight: 600,
                    fontSize: 'var(--text-2xl)',
                    background: 'var(--gradient-orange)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                }}>
                    {props.name}
                </h1>
            )}
            
            <div className="empty-state">
                <div className="empty-state-icon">📋</div>
                <h3 className="empty-state-title">{props.name}</h3>
                <p className="empty-state-description">
                    {props.text}
                </p>
            </div>
        </div>
    )
}

export default EmptyTable